import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import PickerHeader from '../PickerHeader';
import BedInlineInput from '../../../../entities/patient/BedInlineInput';
import Troubleshooting from '../../tablet/Troubleshooting';

const FullScreenOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${props => props.theme.backgroundColor.string()};
  z-index: 1000;
  display: flex;
  flex-direction: column;
`;

const Content = styled.div`
  padding: 0 1em 1em;
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
`;

const BedSlots = styled.div`
  display: grid;
  gap: 0.5rem;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  grid-auto-rows: min-content;
  overflow-y: auto;
  align-content: start;
`;

const BedSlotWrapper = styled.button`
  border: none;
  color: inherit;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.1);
  font-size: 4rem;
  border-radius: 0.25rem;
  aspect-ratio: 1;
  min-height: 120px;
  cursor: pointer;

  &:active {
    background: #00b641;
  }

  &:disabled {
    opacity: 0.25;
    background: rgba(255, 255, 255, 0.05);
    color: rgba(255, 255, 255, 0.3);
    cursor: not-allowed;
  }
`;

const BedSlot = ({ bedNumber, disabled, onClick }) => (
  <BedSlotWrapper disabled={disabled} onClick={disabled ? () => {} : () => onClick(bedNumber)}>
    <span>{bedNumber}</span>
  </BedSlotWrapper>
);

export const alphabet = 'abcdefghijklmnopqrstuvwxyz';

class PreOpPatientBedPicker extends React.Component {
  handleAssignBed = async bedNumber => {
    await this.props.onAssignBed(bedNumber);
    this.props.goToStartPage();
  };

  render() {
    const isAlphabeticBedOrder = this.props.room.isAlphabeticBedOrder;
    return (
      <FullScreenOverlay>
        <Content>
          <PickerHeader
            bedInput={<BedInlineInput onClick={this.handleAssignBed} />}
            onCancel={this.props.onCancel}
            title={'Assign Bed'}
          />
          <BedSlots>
            {this.props.beds.map((bed, i) => (
              <BedSlot
                key={i}
                bedNumber={isAlphabeticBedOrder ? alphabet.charAt(i % 26).toUpperCase() : i + 1}
                disabled={bed.occupied}
                onClick={this.handleAssignBed}
              />
            ))}
          </BedSlots>
        </Content>
        <Troubleshooting roomName={this.props.room.name} />
      </FullScreenOverlay>
    );
  }
}

PreOpPatientBedPicker.propTypes = {
  beds: PropTypes.arrayOf(
    PropTypes.shape({
      occupied: PropTypes.bool,
    })
  ).isRequired,
  onAssignBed: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  goToStartPage: PropTypes.func.isRequired,
  room: PropTypes.shape({
    name: PropTypes.string,
    isAlphabeticBedOrder: PropTypes.bool,
  }).isRequired,
};

export default PreOpPatientBedPicker;
